export default __webpack_public_path__ + "static/media/Gold_Mar21_Rank.dc81311d.png";